import React from 'react';
import query from 'querystringify';

// Components
import {
	SearchPageStruct,
	MatPreviewModal,
	MainHeader,
	MatPreview,
	MainStruct,
	Container,
} from '../../components';
import { setMatName } from '../../redux/actionCreators/mat';
import {
	showLoadMoreButton as showLoadMoreButtonAction,
	toggleSketchForFavourite,
	getMoreSearchSketches,
	getSearchSketches,
} from '../../redux/actionCreators/mats';
// Action creators
import { setActiveSketchPreview } from '../../redux/actionCreators/sketch';
import { toggle } from '../../redux/actionCreators/ui';
// Selectors
import getById from '../../redux/selectors/getById';
// Action types
import {
	GET_MORE_SEARCH_MATS_$NETWORK,
	GET_SEARCH_MATS_$NETWORK,
} from '../../redux/types/mats';
// Static
import browserHistory from '../../static/global';

// Utils
import { getMatFavouriteStatus, getMatStatus } from '../../utils';
import addQuery from '../../utils/addQuery';

// ----------------

export default function Search(props) {
	return (
		<>
			<MainStruct
				header={
					<Container
						mapDispatch={{ toggle }}
						mapState={(state) => ({
							favouriteQuantity: state.mats.favouriteSketchesQty,
							sidebarOpen: state.ui.active.sidebar,
						})}
						render={MainHeader}
					/>
				}
			>
				<Container
					mapDispatch={{
						showLoadMoreButtonAction,
						toggleSketchForFavourite,
						setActiveSketchPreview,
						getMoreSearchSketches,
						getSearchSketches,
						toggle,
					}}
					mapState={(state) => ({
						getMoreNetworkProcess: state.network[GET_MORE_SEARCH_MATS_$NETWORK],
						showLoadMoreButton: state.mats.showLoadMoreButton,
						getNetworkProcess: state.network[GET_SEARCH_MATS_$NETWORK],
						searchSketches: state.mats.searchSketches,
					})}
					render={(cProps) => {
						const { history } = browserHistory;
						const q = query.parse(history.location.search);

						return (
							<SearchPageStruct
								loadMoreNetworkProcess={cProps.getMoreNetworkProcess}
								getNetworkProcess={cProps.getNetworkProcess}
								sortActions={[
									{
										onClick: async () => {
											if (q.sortDir !== 'desc') {
												addQuery({ sortDir: 'desc' });
												addQuery({}, ['page']);

												await cProps.getSearchSketches({ searchOrder: 'desc' });
												cProps.showLoadMoreButtonAction(true);
											}
										},
										active: q.sortDir ? q.sortDir === 'desc' : true,
										label: 'Date Decrease',
										icon: 'expand_more',
										id: 'sketches-date-decrease',
									},
									{
										onClick: async () => {
											if (q.sortDir !== 'asc') {
												addQuery({ sortDir: 'asc' });
												addQuery({}, ['page']);

												await cProps.getSearchSketches({ searchOrder: 'asc' });
												cProps.showLoadMoreButtonAction(true);
											}
										},
										active: q.sortDir === 'asc',
										label: 'Date Increase',
										icon: 'expand_less',
										id: 'sketches-date-increase',
									},
								]}
								showLoadMore={cProps.showLoadMoreButton}
								onLoadMore={() => {
									addQuery({ page: q.page ? +q.page + 1 : 2 });
									cProps.getMoreSearchSketches();
								}}
								onSearch={cProps.getSearchSketches}
								list={cProps.searchSketches}
								card={({
									sketchRequestID,
									productGroupID,
									attributeName,
									companyName,
									requestDate,
									designName,
									sketchRef,
									sketchURL,
									imageName,
									viewMode,
									scanURL,
									...cardProps
								}) => (
									<MatPreview
										withFavouriteIcon
										onFavouriteClick={(id, favourite) =>
											favourite === 1
												? cProps.toggleSketchForFavourite(id, 'delete', 'searchSketches')
												: cProps.toggleSketchForFavourite(id, 'add', 'searchSketches')
										}
										withHoverEffect
										withMatType
										companyName={companyName}
										imageName={imageName || undefined}
										favourite={getMatFavouriteStatus(cardProps)}
										maxWidth="auto"
										viewMode={viewMode}
										onClick={() => {
											cProps.setActiveSketchPreview(
												sketchRequestID,
												'sketch',
												'searchSketches'
											);
											cProps.toggle('matPreviewModal');
										}}
										sketchRef={sketchRef}
										status={getMatStatus(cardProps)}
										image={sketchURL || scanURL}
										size={attributeName}
										name={designName}
										date={requestDate}
										type={productGroupID || undefined}
										id={sketchRequestID}
									/>
								)}
								{...cProps}
							/>
						);
					}}
				/>
			</MainStruct>

			<Container
				mapDispatch={{
					toggleSketchForFavourite,
					setMatName,
					toggle,
				}}
				mapState={(state) => ({
					matDetails:
						(state.sketch.activeSketchPreview &&
							getById(
								state.mats.searchSketches,
								'sketchRequestID',
								state.sketch.activeSketchPreview.id
							)) ||
						{},
					modalOpen: state.ui.active.matPreviewModal,
				})}
				render={({
					matDetails: {
						sketchRequestID,
						productGroupID,
						attributeName,
						companyName,
						requestDate,
						designName,
						sketchRef,
						imageName,
						sketchURL,
						scanURL,
						...matProps
					},
					...cProps
				}) => (
					<MatPreviewModal
						onVariation={() => {
							cProps.setMatName(designName);
							cProps.toggle('matPreviewModal');
							cProps.toggle('variationSketchModal');
						}}
						onApprove={() => {
							cProps.toggle('matPreviewModal');
							cProps.toggle('customerApprovalModal');
						}}
						onPreview={() => {
							cProps.toggle('matPreviewModal');
							browserHistory.history.push(`/preview/${sketchRequestID}`);
						}}
						onClose={() => cProps.toggle('matPreviewModal')}
						open={cProps.modalOpen || false}
						data={{
							withFavouriteIcon: true,
							onFavouriteClick: (id, favourite) =>
								favourite === 1
									? cProps.toggleSketchForFavourite(id, 'delete', 'searchSketches')
									: cProps.toggleSketchForFavourite(id, 'add', 'searchSketches'),
							companyName: companyName,
							imageName: imageName,
							sketchRef: sketchRef,
							favourite: getMatFavouriteStatus(matProps),
							status: getMatStatus(matProps),
							image: sketchURL || scanURL,
							type: productGroupID || undefined,
							size: attributeName,
							name: designName,
							date: requestDate,
							id: sketchRequestID,
						}}
					/>
				)}
			/>
		</>
	);
}
